import React from 'react';
import {Query, Mutation} from 'react-apollo';
import {adopt} from 'react-adopt';

import {GET_MEMBERSHIPS, GET_MEMBERSHIP_DATA, UPDATE_MEMBERSHIP, GET_CLUB_LANGUAGES} from '../../../../graphql';
import {Region, Club, Membership, MembershipText, Language} from '../../../../interfaces';

export interface QueryAndMutationForMembershipObject {
  membershipData: {
    membership?: Membership;
    club?: Club;
    region?: Region;
    loading?: boolean;
    error?: Error;
  };
  memberships?: {
    loading?: boolean;
    error?: Error;
    memberships?: Array<any>;
  };
  clubLanguages: {
    loading?: boolean;
    error?: Error;
    languages?: Array<Language>;
  };
  updateMembership: (data: UpdateMembershipInput) => Promise<Membership>;
}

export interface UpdateMembershipInput {
  variables: {
    data: {
      id: string | number;
      membershipExternalId: string;
      active: boolean;
      ospAvailable: boolean;
      dspAvailable: boolean;
      isDefault: boolean;
      priority: number;
      texts: Array<{
        id: string;
        title: string;
        description: string;
        termsAndConditions: string;
      }>;
    };
  };
}

const QueryAndMutationForMembership = adopt({
  membershipData: ({render, clubId, regionId, membershipExternalId}) => (
    <Query query={GET_MEMBERSHIP_DATA} variables={{clubId, regionId, membershipExternalId}}>
      {({loading, error, data: {club, membership, region}}: any) => {
        if (loading) {
          return render({loading});
        }

        if (error) {
          return render({error});
        }

        const parsedMembership: Membership = {
          id: membership.id,
          active: membership.active,
          membershipExternalId: membership.membershipExternalId,
          priority: membership.priority,
          ospAvailable: membership.ospAvailable,
          dspAvailable: membership.dspAvailable,
          isDefault:membership.isDefault,
          texts: membership.texts.map((text: MembershipText) => ({
            id: text.id,
            title: text.title,
            description: text.description,
            termsAndConditions: text.termsAndConditions,
            language: {
              id: text.language.id,
              code: text.language.code,
              name: text.language.name,
            },
          })),
        };

        return render({
          membership: parsedMembership,
          club,
          region,
        });
      }}
    </Query>
  ),
  memberships: ({render, clubId}) => (
    <Query query={GET_MEMBERSHIPS} variables={{clubId}}>
      {({loading, error, data: {memberships}}: any) => {
        if (loading) {
          return render({loading});
        }

        if (error) {
          return render({error});
        }

        return render({memberships});
      }}
    </Query>
  ),
  clubLanguages: ({render, clubId}) => (
    <Query query={GET_CLUB_LANGUAGES} variables={{clubId}}>
      {({loading, error, data: {clubLanguages}}: any) => {
        if (loading) {
          return render({loading});
        }

        if (error) {
          return render({error});
        }

        return render({languages: clubLanguages});
      }}
    </Query>
  ),
  updateMembership: ({render, clubId, regionId, membershipExternalId}) => (
    <Mutation
      mutation={UPDATE_MEMBERSHIP}
      variables={{clubId}}
      refetchQueries={[
        {query: GET_MEMBERSHIP_DATA, variables: {clubId, regionId, membershipExternalId}},
        {query: GET_MEMBERSHIPS, variables: {clubId}},
      ]}
    >
      {(updateMembership: any) => render(updateMembership)}
    </Mutation>
  ),
});

export default QueryAndMutationForMembership;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipDetail/components/QueryMutation/QueryMutation.tsx